import { Modal } from 'components/atoms/Modal';
import { IconClose } from 'components/atoms/icons/IconClose';
import { SelectField } from 'components/molecules/SelectField';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TSelectTruckModal } from 'types/Collect';
import { TModal } from 'types/modal';
import { SelectOption } from '../EditCompressionsResourceDataModal';
import styles from './CollectEmissionsSelectTruckModal.module.scss';
import { getTruckDrivers } from 'apis/collect_user';
import { useEffect, useState } from 'react';

type TruckModalProps = TModal & {
  closeModal: () => void;
  onSubmit: (truckId: string) => void;
};

const CollectEmissionsSelectTruckModal = ({
  closeModal,
  onSubmit,
}: TruckModalProps) => {
  const { t } = useTranslation();
  const [truckOptions, setTruckOptions] = useState<SelectOption[]>([]);

  const fetchTruckDrivers = () => {
    getTruckDrivers({
      successCallback: (data) => {
        setTruckOptions(
          data.trucks.map(({ id, truckNumber }) => ({
            label: truckNumber,
            value: id,
          }))
        );
      },
      failedCallback: () => {
        setTruckOptions([]);
      },
    });
  };

  useEffect(() => {
    fetchTruckDrivers();
  }, []);

  return (
    <section className={styles['truck-modal']}>
      <Modal>
        <div className={styles['customTitle']}>
          <div className={styles['title']}>
            {t('collect_registration.trucks_modal.title')}
          </div>
          <div className={styles['top']} onClick={closeModal}>
            <IconClose />
          </div>
        </div>
        <div className={styles['form-body']}>
          <Form<TSelectTruckModal>
            onSubmit={(value: TSelectTruckModal) => onSubmit(value.truckId)}
            render={({ handleSubmit, invalid }) => (
              <form onSubmit={handleSubmit} className={styles['form-body']}>
                <div className={styles['selectBox']}>
                  <SelectField
                    name="truckId"
                    options={truckOptions}
                    label={t('collect_registration.trucks_modal.truck_id')}
                    placeholder={t(
                      'collect_registration.trucks_modal.truck_id'
                    )}
                    isDarkmode
                    searchable
                  />
                </div>
                <div className={styles['submit']}>
                  <button
                    className={styles['submitButton']}
                    type="submit"
                    disabled={invalid}
                  >
                    {t('common.button.next')}
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      </Modal>
    </section>
  );
};

export default CollectEmissionsSelectTruckModal;
